import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-4c1e9022"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "diagnose-popup-container"
};
var _hoisted_2 = {
  class: "header"
};
var _hoisted_3 = {
  class: "title"
};
var _hoisted_4 = {
  key: 0,
  class: "loading"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", null, "正在检测中", -1);
});
var _hoisted_6 = {
  key: 1,
  class: "container"
};
var _hoisted_7 = {
  class: "diagnose-result"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "result-label"
  }, "检测结果：", -1);
});
var _hoisted_9 = {
  class: "result-content"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "卡片正常", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", null, "卡片异常", -1);
});
var _hoisted_12 = {
  class: "diagnose-suggestions"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "suggestions-label"
  }, "系统建议：", -1);
});
var _hoisted_14 = {
  key: 0,
  class: "suggestions-content"
};
var _hoisted_15 = {
  key: 1,
  class: "suggestions-content"
};
import { apiDiagnosis } from "@/common/api";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'DiagnosePopup',
  props: {
    iccid: null
  },
  setup: function (__props, _a) {
    var expose = _a.expose;
    var props = __props;
    var diagnosePopupVisible = ref(false);
    var diagnosisInfo = ref({});
    var diagnosing = ref(false);
    // 1-卡片正常,2-卡片异常
    function diagnosis() {
      diagnosing.value = true;
      apiDiagnosis({
        iccid: props.iccid
      }).then(function (res) {
        diagnosisInfo.value = res.data;
        setTimeout(function () {
          diagnosing.value = false;
        }, 1000);
      });
    }
    function open() {
      diagnosePopupVisible.value = true;
      diagnosis();
    }
    function close() {
      diagnosePopupVisible.value = false;
    }
    expose({
      open: open,
      close: close
    });
    return function (_ctx, _cache) {
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_loading = _resolveComponent("van-loading");
      var _component_van_popup = _resolveComponent("van-popup");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: diagnosePopupVisible.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return diagnosePopupVisible.value = $event;
        }),
        round: "",
        class: "diagnose-popup"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, "设备卡号：" + _toDisplayString(props.iccid), 1), _createElementVNode("div", {
            class: "close-button",
            onClick: close
          }, [_createVNode(_component_van_icon, {
            name: "close",
            size: "20px"
          })])]), diagnosing.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_van_loading, {
            type: "spinner",
            size: "56px"
          }), _hoisted_5])) : (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [diagnosisInfo.value.cardStatus === '1' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_van_icon, {
            name: "checked",
            color: "#29cc65",
            size: "16px"
          }), _hoisted_10], 64)) : diagnosisInfo.value.cardStatus === '2' ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createVNode(_component_van_icon, {
            name: "warning",
            color: "#ef5250",
            size: "16px"
          }), _hoisted_11], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_12, [_hoisted_13, true ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(diagnosisInfo.value.suggest), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_15, " 系统已自动修复，请您将【设备断电】5分钟后再重启，如仍未能恢复，请联系在线客服咨询。 "))])]))];
        }),
        _: 1
      }, 8, ["show"])]);
    };
  }
});